<template>
  <div class="grid pricelist">
    <!-- {{season.pricelist}} -->
    <!-- {{segments}} -->
    <!-- {{seasonindex}} -->
    <!-- {{pricelist}} -->
    <div class="grid btnlist" style="margin-top: 0; margin-bottom: 48px; grid-template-columns: auto; justify-content: end; grid-column-gap: 64px;">
      <button type="button" class="btn green block sm" @click="addprice">aggiungi riga</button>
      <button type="button" class="btn green block sm" @click="saveSeason"><unicon name="save" fill="#fff" /> Salva modifiche</button>
    </div>
<!--     <el-form key="form" ref="pricelistform"  status-icon>

      <div class="grid" v-for="(price, index) in pricelist" :key="index" style="grid-auto-flow: column;">
        
        <el-form-item label="giorni" >
          <el-input type="text" v-model="price.period" name="day"></el-input>
        </el-form-item>

        <el-form-item label="Ombrellone 1a fila" >
          <el-input type="text" v-model="price.umbrellaprice" name="umbrellaprice"></el-input>
        </el-form-item>

      </div>

    </el-form> -->

    <!-- {{season.pricelist}} -->
<!--     <div v-for="(list, index) in season.pricelist" :key="index">
      <p v-for="(segment, indexs) in list.segments" :key="indexs">{{segment}}</p>
    </div> -->

    <el-table
      :data="season.pricelist"
      style="width: 100%"
      height="80vh"
      class="pricetable">
      <el-table-column
        fixed
        prop="period"
        label="Giorni"
        width="70">
        <template slot-scope="scope">
          <el-input type="text" v-model="scope.row.period" name="day"></el-input>
        </template>
      </el-table-column>

      <el-table-column :label="segments.length > 1 ? 'Prezzo Ombrelloni e Segmenti' : 'Prezzo Ombrelloni'">
        <el-table-column
          prop="segments"
          v-for="(segment, indexs) in segments"
          :key="'s'+indexs"
          :label="segment.name === 'default' ? 'Standard' : segment.name"
          width="120">
          <template slot-scope="scope">
            <!-- {{scope.row.segments}}
            {{indexs}} -->
            <el-input type="text" v-if="scope.row.segments && scope.row.segments[indexs]" v-model="scope.row.segments[indexs].price" name="">
              <unicon slot="prefix" name="euro" fill="#808080" width="14" />
            </el-input>
            <span v-else>{{indexs}}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="Oggetti">
        <el-table-column
          prop="items"
          v-for="(item, index) in items"
          :key="index"
          :label="item.name"
          width="120">
          <template slot-scope="scope">
            <el-input type="text" v-model="scope.row.items[index].price" name="">
              <unicon slot="prefix" name="euro" fill="#808080" width="14" />
            </el-input>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        fixed="right"
        label=""
        width="40">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index)"
            type="text"
            size="small"
            v-if="scope.$index !== 0">
            <unicon name="trash" fill="#808080" width="14" />
          </el-button>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
  name: 'Pricelist',
  // mixins: [helper],
  props: {
    season: Object,
    seasonindex: Number
  },
  data () {
  return {
    changes: false,
    // pricelist: this.season.pricelist || [],
    items: JSON.parse(JSON.stringify(this.season.items)),
    segments: JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.segments))
  }
  },
  methods: {
    checkSegments () {
      console.log('checkSegments')
    },
    addprice () {
      console.log('addprice')
      this.season.pricelist.push({
        period: (this.season.pricelist.length + 1).toString(),
        // firstrow: 0,
        // secondrow: 0,
        // thirdrow: 0,
        // segments: JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.segments)),
        // segments: _.map(this.$store.state.hotels.activehotel.segments, function (segment) {
        //   return
        // }),
        segments: _.map(this.$store.state.hotels.activehotel.segments, function (segment) {
          _.unset(segment, ['ombrelloni'])
          segment.price = '0'
          return JSON.parse(JSON.stringify(segment))
        }),
        items: JSON.parse(JSON.stringify(this.season.items))
      })
    },
    async saveSeason () {
      console.log('savePricelist ', this.season.pricelist)
      _.map(this.season.pricelist, function (row) {
        _.map(row.items, function (item) {
          if (isNaN(item.price)) {
            item.price = item.price.replace(',', '.')
          }
          // item.price.replace(',', '.')
        })
        _.map(row.segments, function (segment) {
          if (isNaN(segment.price)) {
            segment.price = segment.price.replace(',', '.')
          }
        })
        return row
      })
      console.log('savePricelist2 ', this.season.pricelist)
      this.$emit('savePricelist')
      // this.$store.dispatch('hotels/updateSeasons', this.hotel.seasons).then(() => {
      //   this.editseason = false
      // })
    },
    deleteRow(index) {
      console.log(index)
      // rows.splice(index, 1);
      this.season.pricelist.splice(index, 1);
    },
    show (section) {
      console.log(section)
      this.$emit('open', section)
    },
    save () {
      console.log('save')
      // this.$store.dispatch('hotels/updateHotel', this.hotel)
    }
  },
  filters: {

  },
  watch: {

  },
  computed: {
    // segments () {
    //   return _.map(this.$store.state.hotels.activehotel.segments, function (o) {
    //     // var name = o.name
    //     return {o.name: o.price}
    //   })
    // }
    // pricelist () {
    //   if (this.season.pricelist) {
    //     return this.season.pricelist
    //   } else {
    //     return []
    //   }
    // }
  },
  beforeUpdate () {
    this.$nextTick(function () {
      var self = this
      // console.log('small ', _.map(this.season.pricelist, function (listitem) {
      //   // console.log('l: ', listitem.segments)
      //     var differences = _.differenceBy(self.$store.state.hotels.activehotel.segments, listitem.segments, 'name')
      //     var toremove = _.differenceBy(listitem.segments, self.$store.state.hotels.activehotel.segments, 'segmentid')
      //     console.log(listitem.period, differences, toremove)
      //     if (differences.length > 0) {
      //       _.forEach(differences, (difference) => {
      //         // console.log(listitem.period, difference)
      //         listitem.segments.push(JSON.parse(JSON.stringify(difference)))
      //       })
      //     }
      //     if (toremove.length > 0) {
      //       _.forEach(toremove, (item) => {
      //         _.remove(listitem.segments, function (segment) {
      //           return segment.segmentid === item.segmentid
      //         })
      //       })
      //     }
      //     return listitem
      //   }))
      _.map(this.season.pricelist, function (listitem) {
        // console.log('l: ', listitem.segments)
          var differences = _.differenceBy(self.$store.state.hotels.activehotel.segments, listitem.segments, 'name')
          var toremove = _.differenceBy(listitem.segments, self.$store.state.hotels.activehotel.segments, 'segmentid')
          console.log(listitem.period, differences, toremove)
          if (differences.length > 0) {
            _.forEach(differences, (difference) => {
              // console.log(listitem.period, difference)
              listitem.segments.push(JSON.parse(JSON.stringify(difference)))
            })
          }
          if (toremove.length > 0) {
            _.forEach(toremove, (item) => {
              _.remove(listitem.segments, function (segment) {
                return segment.segmentid === item.segmentid
              })
            })
          }
          return listitem
        })
    })
  },
  beforeMount () {
    // console.log(this.season.pricelist.segments)
    // if (this.season.pricelist.segments == undefined) {
    //   console.log(this.season.name + ' no segments')
    // }
  },
  beforeDestroy () {
    // console.log(this.season.pricelist)
  },
  destroyed () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
